import { PlusIcon } from '~/svgs';
import { Button } from '.';

type AddButtonProps = {
   title: React.ReactNode;
   onClick?: () => any;
   disabled?: boolean;
};

export const AddButton = ({ onClick, title, disabled }: AddButtonProps) => {
   return (
      <Button
         disabled={disabled}
         onClick={onClick}
         className="!px-0 text-primary group disabled:opacity-70">
         <span
            className="flex items-center justify-center transition-all duration-200 border 
         rounded-full ltr:mr-2 rtl:ml-2 border-primary w-5 h-5 group-hover:text-white 
         group-disabled:!bg-white group-disabled:!text-primary
         group-focus:text-white group-focus:bg-primary group-hover:bg-primary">
            <PlusIcon className="!w-3" />
         </span>
         <span className=" text-sm font-normal">{title}</span>
      </Button>
   );
};
